module.exports = __webpack_public_path__ + "img/CPTemp15.f2cae2b5.png";